<template>
    <div v-if="hasPeopleToReview !== null" class="mt-3">
        <BaseButton theme="tertiary" size="sm" class="whitespace-normal! text-left" @click="handleToggle">
            <template v-if="hasPeopleToReview">
                <i class="bi bi-dash-circle mr-1" aria-hidden="true"></i>
                {{ t("moments.reviewSwitcher.stopReviewingOthers", { momentTitle }) }}
            </template>
            <template v-else>
                <i class="bi bi-plus-circle mr-1" aria-hidden="true"></i>
                {{ t("moments.reviewSwitcher.startReviewingOthers", { momentTitle }) }}
            </template>
        </BaseButton>
        <BaseToast v-model:open="isErrorToastOpen" theme="error" :description="errorMessage" />
    </div>
</template>

<script setup lang="ts">
import { router } from "@inertiajs/vue3";
import { useFetch } from "~vue/api";
import BaseButton from "~vue/components/BaseButton.vue";
import BaseToast from "~vue/components/BaseToast.vue";
import { logUserInteraction } from "~vue/utils/logUtils";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";

import { PERFORMANCE_REVIEW_EVENT_PREFIX } from "./constants";

const props = withDefaults(
    defineProps<{
        hasPeopleToReview?: boolean | null;
        momentId?: string | number | null;
        momentTitle?: string | null;
    }>(),
    {
        hasPeopleToReview: null,
        momentId: null,
        momentTitle: "",
    },
);

const { execute: sendReviewSelection, error: sendReviewSelectionError } = useFetch("/api/coach/performance_reviews/user_data/", { immediate: false })
    .post(computed(() => ({ has_people_to_review: !props.hasPeopleToReview })))
    .json();

const { t } = useI18n();

const isErrorToastOpen = ref(false);
const errorMessage = ref("");

const handleToggle = async () => {
    await sendReviewSelection();
    if (sendReviewSelectionError.value) {
        errorMessage.value = t("moments.reviewSwitcher.updateError");
        isErrorToastOpen.value = true;
        return;
    }

    logUserInteraction(`${PERFORMANCE_REVIEW_EVENT_PREFIX}has_people_to_review_selected`, { has_people_to_review: !props.hasPeopleToReview, moment_id: props.momentId });
    router.reload({ only: ["has_people_to_review"] });
};
</script>
